export default __webpack_public_path__ + "static/media/icon-star.9c734287.svg";